<app-navbar [toogle]="toogle" (isToogle)="handleToogle($event)"></app-navbar>
<app-menu [toogle]="toogle" (changeToogle)="hideToogle($event)"></app-menu>
<div class="pt-14">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
